// extracted by mini-css-extract-plugin
export var Black = "index-module--Black--9-uQo";
export var MobilePaddingWrap = "index-module--MobilePaddingWrap--HQ3YX";
export var SectionContent = "index-module--SectionContent--xJu+M";
export var SectionContentTitle = "index-module--SectionContentTitle--jxguJ";
export var SectionHeaderMobile = "index-module--SectionHeaderMobile--sfmm3";
export var UseSectionHeaderMobile = "index-module--UseSectionHeaderMobile--Bzbh8";
export var hideUnderline = "index-module--hideUnderline--6XBE8";